

exports.__esModule = true;
exports.$FallbackError = exports.$BatchShortCircuit = exports.$ApiError = exports.$Forbidden = exports.$Contingency = exports.$Error = undefined;

var _event = require('./event');

var _class = require('./class');

var _util = require('./util');

_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
    var message = _ref[0];
    var file = _ref[1];
    var line = _ref[2];
    var col = _ref[3];
    var err = _ref[4];


    original();

    _event.$event.emit('$windowError', {
        message: message && (message.stack || message).toString(),
        file: file && file.toString(),
        line: line && line.toString(),
        col: col && col.toString(),
        stack: err && (err.stack || err).toString()
    });
});

var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {

    construct: function construct(err, properties) {

        if (err instanceof Error) {
            err = err.message;
        }

        if (properties) {
            _util.$util.extend(this, properties);
        }

        this.payload = properties;

        this.message = err;
    }
});

var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
    handle: function handle(handlers) {
        var handler = handlers[this.message] || handlers['DEFAULT'];
        if (handler) {
            var result = handler.call(this, this.message, this);
            if (typeof result !== 'undefined') {
                return result;
            }
            return true;
        }
    }
});

var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');

var $ApiError = exports.$ApiError = $Error.extend('$ApiError');

var $BatchShortCircuit = exports.$BatchShortCircuit = $Error.extend('$BatchShortCircuit');

var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
    init: function init() {
        this.reason = this.reason || '';
        this.product = this.product || '';
        this.entryPoint = this.entryPoint || '';
    }
});

angular.value("$Error", $Error);
angular.value("$Contingency", $Contingency);
angular.value("$Forbidden", $Forbidden);
angular.value("$ApiError", $ApiError);
angular.value("$BatchShortCircuit", $BatchShortCircuit);
angular.value("$FallbackError", $FallbackError);
_event.$event;

_class.$Class;

_util.$util;


/*****************
 ** WEBPACK FOOTER
 ** ./components/squid/dist/core/error.js
 ** module id = 126
 ** module chunks = 1
 **/